function isBenefitsCompatible(benefitA, benefitB) {
  if (!Array.isArray(benefitA.compatibleWith) || !Array.isArray(benefitB.compatibleWith)) {
    return false;
  }
  const isOptionACompatible = benefitB.compatibleWith.some((compatibleOption) => compatibleOption.id === benefitA.id);
  const isOptionBCompatible = benefitA.compatibleWith.some((compatibleOption) => compatibleOption.id === benefitB.id);
  return isOptionACompatible && isOptionBCompatible;
}
const getCompatibleBenefits = (benefits, checkingBenefit, selectedBenefits) => {
  const compatibleBenefits = benefits.filter(
    (benefit) => isBenefitsCompatible(benefit, checkingBenefit)
  );
  if (!selectedBenefits.length) {
    return compatibleBenefits;
  }
  const benefitsCompatibleWithSelected = compatibleBenefits.filter((compatibleBenefit) => {
    const isCompatibleWithSelected = selectedBenefits.every((selectedBenefit) => {
      if (selectedBenefit.id === compatibleBenefit.id) {
        return true;
      }
      return isBenefitsCompatible(compatibleBenefit, selectedBenefit);
    });
    return isCompatibleWithSelected;
  });
  return benefitsCompatibleWithSelected;
};
export {
  getCompatibleBenefits
};
